import type { PendingForm } from '@/api/types/Forms'
import { GlyphBadge } from '@/components/svgs/Glyph'
import { ListRow } from '@/ui/core/list-row'
import { router } from 'expo-router'

export const openForm = (form: PendingForm) => router.push(`/forms/${form.id}`)

/** A form waiting on the patient that no upcoming visit claims. */
export const TodoFormRow = ({ form }: { form: PendingForm }) => (
	<ListRow
		label={form.name}
		caption="A few questions before we see you."
		leading={<GlyphBadge name="tooth" size={36} tone="mint" />}
		onPress={() => openForm(form)}
	/>
)
